import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import React, { useEffect } from 'react';
import { analyticsService } from 'services/analytics/analyticsService';

import styles from './styles';

const SubscriptionSuccess = () => {
  useEffect(() => {
    // Track subscription success
    analyticsService.trackSubscriptionFlow('success');
  }, []);

  const handleGoToDashboard = () => {
    // Aqui você pode adicionar a navegação para a tela principal
  };

  return (
    <Box sx={styles.container}>
      <Card sx={styles.card}>
        <CardContent sx={styles.content}>
          <CheckCircleIcon sx={styles.icon} />
          <Typography variant="h4" sx={styles.title}>
            Solicitação deAssinatura Concluída!
          </Typography>
          <Typography variant="body1" sx={styles.message}>
            Seu pedido foi processado com sucesso. Assim que o pagamento for
            confirmado, você receberá um e-mail com os detalhes da sua
            assinatura.
            <br />
            Bem-vindo ao Clube da 42!
          </Typography>
          <Button
            variant="contained"
            sx={styles.button}
            onClick={handleGoToDashboard}
          >
            Ir para a Loja
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SubscriptionSuccess;
